<template>
	<div class="evento" @click="$emit('click')">
		<div class="evento-top">
			<img class="evento-foto" :src="evento.Evento.EventoFotoPrincipal" :alt="evento.Evento.EventoNombre">
			<!-- <img src="https://files.redtickets.uy/imagenes/aadc09ca-4828-435d-a2e5-0414b0a7eacb_Event_13293." :alt="evento.Evento.EventoNombre"> -->
			<div class="evento-involucrados">
				<div class="involucrado" :data-tooltip="evento.Involucrados.InstitucionLocalNombre" v-if="Number(evento.Involucrados.InstitucionLocalId) > 0 && evento.Involucrados.InstitucionLocalEscudo" :style="{ 'background-color': '#' + evento.Involucrados.InstitucionLocalBackgroundColor}">
					<img :src="evento.Involucrados.InstitucionLocalEscudo" :alt="evento.Involucrados.InstitucionLocalNombre" />
				</div>
				<!-- <div class="involucrado" :data-tooltip="evento.Involucrados.InstitucionVisitanteNombre" v-if="Number(evento.Involucrados.InstitucionVisitanteId) > 0 && evento.Involucrados.InstitucionVisitanteEscudo" :style="{ 'background-color': '#' + evento.Involucrados.InstitucionVisitanteBackgroundColor}">
					<img :src="evento.Involucrados.InstitucionVisitanteEscudo" :alt="evento.Involucrados.InstitucionVisitanteNombre" />
				</div> -->
				<div class="involucrado" :data-tooltip="evento.Involucrados.OrganizadorNombre" v-if="!Number(evento.Involucrados.InstitucionLocalId) > 0" :style="{ 'background-color': '#' + evento.Involucrados.OrganizadorBackgroundColor}">
					<img :src="evento.Involucrados.OrganizadorLogo" :alt="evento.Involucrados.OrganizadorNombre" />
				</div>
			</div>
		</div>
		<div class="evento-main">
			<div class="evento-main-content">
				<div class="evento-tipo">
					{{ evento.Categorias.EventoCategoriaNombre }}
				</div>
				<div class="evento-main-top">
					<span class="evento-title">{{ evento.Evento.EventoNombre }}</span>
					<div class="evento-fecha">
						<span class="fecha-dia">{{ evento.Fecha.EventoFechaDia }}</span>
						<span class="fecha-mes">{{ evento.Fecha.EventoFechaMes }}</span>
						<!-- <span class="fecha-hora">{{ evento.Fecha.EventoFechaHora }}</span> -->
					</div>
				</div>
				<div class="evento-lugar">
					<i class='bx bx-map' ></i>{{ evento.Escenario.EscenarioNombre }}
				</div>
			</div>
			<div class="evento-main-bottom">
				<!-- <span class="evento-precio-desde">Desde {{ evento.Escenario.MonedaSimbolo.trim() }}{{ evento.Escenario.PrecioDesde.replace('.00', '') }}</span> -->
				<div class="button">Comprar entradas</div>
			</div>
		</div>

		<!-- <div class="evento-top">
			<div class="evento-foto">
				<img :src="evento.Evento.EventoFotoPrincipal" :alt="evento.Evento.EventoNombre" />
			</div>
			<div class="evento-top-content">
				<div class="evento-top-text">
					<span class="evento-tipo">{{ evento.Categorias.EventoCategoriaNombre }}</span>
					<span class="evento-title">{{ evento.Evento.EventoNombre }}</span>
				</div>
				<div class="evento-top-like" :class="evento.liked ? 'liked' : ''">
					<i class="bx bx-heart" v-if="!evento.liked"></i>
					<i class="bx bxs-heart" v-else></i>
				</div>
			</div>
		</div>
		<div class="evento-main">
			<div class="evento-main-left">
				<span class="evento-fecha">{{ evento.Fecha.EventoFechaDiaEscrito }} {{ evento.Fecha.EventoFechaDia }} {{ evento.Fecha.EventoFechaMes }}</span>
				<span class="evento-fecha-hora">{{ evento.Fecha.EventoFechaHora }}</span>
				<span class="evento-lugar"
					><i class="bx bxs-map-pin"></i>{{ evento.Escenario.EscenarioNombre }}</span
				>
			</div>
			<div class="evento-main-right">
				<span class="evento-precio-desde">Desde {{ evento.Escenario.MonedaSimbolo.trim() }}{{ evento.Escenario.PrecioDesde.replace('.00', '') }}</span>
				<div class="button">Ver tickets</div>
			</div>
			<div class="evento-involucrados">
				<div class="involucrado" :data-tooltip="evento.Involucrados.InstitucionLocalNombre" v-if="Number(evento.Involucrados.InstitucionLocalId) > 0 && evento.Involucrados.InstitucionLocalEscudo" :style="{ 'background-color': '#' + evento.Involucrados.InstitucionLocalBackgroundColor}">
					<img :src="evento.Involucrados.InstitucionLocalEscudo" :alt="evento.Involucrados.InstitucionLocalNombre" />
				</div>
				<div class="involucrado" :data-tooltip="evento.Involucrados.InstitucionVisitanteNombre" v-if="Number(evento.Involucrados.InstitucionVisitanteId) > 0 && evento.Involucrados.InstitucionVisitanteEscudo" :style="{ 'background-color': '#' + evento.Involucrados.InstitucionVisitanteBackgroundColor}">
					<img :src="evento.Involucrados.InstitucionVisitanteEscudo" :alt="evento.Involucrados.InstitucionVisitanteNombre" />
				</div>
				<div class="involucrado" :data-tooltip="evento.Involucrados.OrganizadorNombre" v-if="!Number(evento.Involucrados.InstitucionLocalId) > 0" :style="{ 'background-color': '#' + evento.Involucrados.OrganizadorBackgroundColor}">
					<img :src="evento.Involucrados.OrganizadorLogo" :alt="evento.Involucrados.OrganizadorNombre" />
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	export default {
		props: ['evento'],
	};
</script>

<style lang="scss" scoped>
	.evento{
		@include flex(column, flex-start, flex-start);
		position: relative;
		width: 100%;
		user-select:none;
		// max-width: 380px;
		min-height: 454px;
		// overflow: hidden;
		// border-radius: 16px;
		// @include transition(all 0.3s ease);
		// aspect-ratio: 7/9;
		cursor: pointer;
		// background-color: var(--color-white);
		// border: 1px solid #dbdbdb;
		// box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;

		border: 1px solid #ffffff22;
		background-color: #282c34;
		background: linear-gradient(0deg, rgba(40,44,52,1) 0%, rgba(17,0,32,.5) 100%);
		box-shadow: 0 7px 20px 5px #00000088;
		border-radius: .7rem;
		backdrop-filter: blur(7px);
		-webkit-backdrop-filter: blur(7px);
		overflow: hidden;
		@include transition(.5s all);

		padding: 13px;

		// &:after{
		// 	content: '';
		// 	position: absolute;
		// 	background: var(--color-primary);
		// 	// background: linear-gradient(270deg, rgba(255,255,255,1) 0%, var(--color-primary) 76%);
		// 	width: 100%;
		// 	height: 100%;
		// 	top: 0px;
		// 	left: 0px;
		// 	z-index: -1;
		// 	border-radius: 16px;
		// 	@include transition(all .3s);
		// }

		// &:hover{
		// 	border: 1px solid var(--color-secondary);
		// 	&:after{
		// 		content: '';
		// 		top: 8px;
		// 		left: 8px;
		// 	}

		// 	.evento-main{
		// 		.evento-main-bottom{
		// 			.button{
		// 				background-color: var(--color-primary);
		// 				color: var(--color-darker);
		// 			}
		// 		}
		// 	}
		// }

		::before:not(i){
			position: fixed;
			content: "";
			box-shadow: 0 0 100px 40px #ffffff08;
			top: -10%;
			left: -100%;
			transform: rotate(-45deg);
			height: 60rem;
			transition: .7s all;
		}

		&:hover{
			border: 1px solid #ffffff44;
			box-shadow: 0 7px 50px 10px #000000aa;
			// transform: scale(1.015);
			// filter: brightness(1.3);

			::before:not(i){
				filter: brightness(.5);
				top: -100%;
				left: 200%;
			}

			.evento-main{
				.evento-main-bottom{
					.button{
						background-color: var(--color-primary);
						color: var(--color-darker);
					}
				}
			}
		}

		.evento-top{
			user-select: none;
			@include flex(row, center, center);
			width: 100%;
			// overflow: hidden;
			position: relative;

			img.evento-foto{
				border-radius: 14px;
				aspect-ratio: 1/1;
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center;
			}

			.evento-involucrados {
				content: "";
				position: absolute;
				left: 50%;
				bottom: -24px;
				width: 48px;
				height: 48px;
				backdrop-filter: blur(4px);
				background: rgba(252, 252, 253, 0.15);
				z-index: 10;
				transform: translateX(-50%);
				border-radius: 50%;
				@include flex(row, center, center);

				// &:before{
				// 	content: '';
				// 	position: absolute;
				// 	bottom: 0px;
				// 	left: 0px;
				// 	background-color: var(--color-white);
				// 	width: 100%;
				// 	height: 23px;
				// 	// z-index: -1;
				// 	// border-radius: 50%;
				// 	// left: -5px;
				// 	// top: -5px;
				// }

				.involucrado {
					position: relative;
					@include transition(all 0.3s ease);
					background-color: var(--color-white);
					border-radius: 99%;
					width: 36px;
					height: 36px;
					@include flex(row, center, center);
					padding: 6px;
					// z-index: 0;

					&:nth-child(1) {
						margin-left: 0;
						// z-index: 10;
					}

					&:nth-child(2),
					&:nth-child(3),
					&:nth-child(4) {
						margin-left: -18px;
					}

					// &:nth-child(2) {
					// 	z-index: 6;
					// }

					// &:nth-child(3) {
					// 	z-index: 5;
					// }

					// &:nth-child(4) {
					// 	z-index: 4;
					// }

					img {
						height: 100%;
						width: 100%;
						object-fit: cover;
					}

					&:after {
						content: attr(data-tooltip);
						background: var(--color-white);
						border-radius: 8px;
						box-shadow: 5px 8px 20px rgba(0, 0, 0, 0.27);
						font-size: 11px;
						font-weight: 400;
						left: 0px;
						opacity: 0;
						padding: 3px 11px;
						position: absolute;
						text-align: center;
						top: -28px;
						@include transition(all 0.3s ease);
						visibility: hidden;
						width: -webkit-max-content;
						width: max-content;
						z-index: 10;
					}

					&:hover {
						// -webkit-transform: scale(1.1);
						// transform: scale(1.1);
						z-index: 10;

						&:after {
							opacity: 1;
							visibility: visible;
						}
					}
				}

				&:hover {
					.involucrado {
						margin-left: 0px !important;
					}
				}
			}
		}

		.evento-main{
			width: 100%;
			height: 100%;
			@include flex(column, space-between, flex-start);
			padding: 0px 6px 2px 6px;
			margin: 15px 0px 0px 0px;

			.evento-main-content{
				width: 100%;
				@include flex(column, flex-start, flex-start);

				.evento-main-top{
					width: 100%;
					@include flex(row, space-between, flex-start);

					.evento-title {
						width: calc(100% - 44px);
						font-family: var(--font-sora);
						color: var(--color-white);
						font-weight: var(--fw-700);
						font-size: 14px;
						padding-right: 12px;
						line-height: 1.45em;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						line-height: 1.45em;
						max-height: 2.9em;
					}

					.evento-fecha{
						width: 44px;
						border-left: 1px solid var(--color-border);
						padding-left: 6px;
						// padding-top: 2px;
						// padding-bottom: 2px;
						// margin-top: -6px;
						@include flex(column, center, center);

						.fecha-dia{
							font-weight: var(--fw-700);
							font-family: var(--font-sora);
							line-height: 1.3em;
							font-size: 15px;
							margin-bottom: 1px;
							color: var(--color-white);
						}

						.fecha-mes{
							font-weight: var(--fw-600);
							font-family: var(--font-sora);
							text-transform: uppercase;
							font-size: 11px;
							line-height: 1.3em;
							// margin-bottom: 1px;
							color: var(--color-white);
						}

						.fecha-hora{
							font-weight: var(--fw-400);
							font-family: var(--font-sora);
							text-transform: uppercase;
							font-size: 11px;
							line-height: 1.3em;
						}
					}
				}

				.evento-lugar{
					@include flex(row, flex-start, center);
					color: rgb(115, 115, 115);
					font-size: 13px;
					line-height: 1.4em;
					font-weight: 400;
					margin-top: 4px;
					color: #a89ec9;

					i{
						margin-top: 1px;
						margin-right: 5px;
					}
				}

				.evento-tipo{
					width: 100%;
					@include flex(column, flex-start, flex-start);
					font-size: 12px;
					font-weight: var(--fw-400);
					margin-bottom: 4px;
					color: #a89ec9;
				}
			}

			.evento-main-bottom{
				width: 100%;
				margin-top: 18px;
				@include flex(row, space-between, center);

				.evento-precio-desde{
					font-size: 11px;
					line-height: 1em;
					color: var(--color-grey);
					font-weight: var(--fw-400);
				}

				.button{
					// text-decoration: underline;
					// font-family: var(--font-inter);
					// font-weight: 700;
					// font-size: 13px;
					// color: var(--color-darker);

					@include flex(row, center, center);
					background-color: var(--color-darker);
					border-radius: 9999px;
					height: 34px;
					color: var(--color-white);
					font-family: var(--font-sora);
					outline: none;
					border: none;
					padding: 0px 16px;
					font-size: 10px;
					font-weight: var(--fw-700);
					line-height: 1em;
					text-transform: uppercase;
					letter-spacing: 0.5px;
					@include transition(all .2s);
					cursor: pointer;
					width: 100%;
				}
			}
		}
	}
</style>